import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useContext } from "react";
import { DialogProvider, createDialogContext } from "../../Common/Dialog";

export const ConfirmDialogContext = createDialogContext();

const ConfirmDialog = ({
  onConfirm,
  onCancel = () => {},
}: {
  onConfirm: () => void;
  onCancel?: () => void;
}) => {
  const { isOpen, close, title, text } = useContext(ConfirmDialogContext);

  const onCloseInternal = () => {
    close();
    onCancel();
  };

  const onConfirmInternal = () => {
    onConfirm();
    close();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onCloseInternal} isCentered>
        <ModalOverlay />
        <ModalContent
          mb={[0, "auto"]}
          borderBottomLeftRadius={[0, "md"]}
          borderBottomRightRadius={[0, "md"]}
        >
          <ModalHeader paddingTop={4}>
            <VStack gap={0} width={"full"}>
              <Text w="full">{title}</Text>
            </VStack>
          </ModalHeader>
          <ModalBody textAlign={"left"}>
            <Text w="full">{text}</Text>
          </ModalBody>
          <ModalFooter>
            <Stack direction={["column-reverse", "row-reverse"]} width="100%">
              <Button key={"cancel"} w={"auto"} onClick={onCloseInternal}>
                Cancel
              </Button>
              <Button
                key={"submit"}
                variant="kydDark"
                w={"auto"}
                onClick={onConfirmInternal}
              >
                Confirm
              </Button>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export const withConfirmDialog =
  <T extends object>(Component: React.ComponentType<T>) =>
  (props: T) => {
    return (
      <DialogProvider context={ConfirmDialogContext}>
        <Component {...(props as T)} />
      </DialogProvider>
    );
  };

export default ConfirmDialog;
